import React, { useState } from 'react';

import { c } from 'ttag';

import { Badge, Button } from '@freelancelabs/components';

import { OrganizationKind } from '../../graphql/__generated__/schema';
import MfaRequirementDialog from './MfaRequirementDialog';

interface Props {
    accountId: string;
    accountName: string;
    mfaRequired: boolean | null | undefined;
    kind: OrganizationKind | null | undefined;
}

const MfaRequirementPanel = ({ accountId, accountName, mfaRequired, kind }: Props) => {
    const [pending, setPending] = useState<boolean | null>(null);

    // Freelance.com carries no such policy: the mutation refuses it, so the button would be a dead control.
    if (kind === OrganizationKind.Internal) {
        return null;
    }

    // Null is not "not required": a missing field must not be read as an answer.
    if (mfaRequired === null || mfaRequired === undefined) {
        return null;
    }

    return (
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2 rounded-lg border border-border-norm bg-background-norm px-4 py-3">
            <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                    <h2 className="text-sm font-semibold text-text-900">
                        {c('MFA requirement').t`Multi-factor authentication`}
                    </h2>
                    <Badge category={mfaRequired ? 'success' : 'default'} size="small">
                        {mfaRequired ? c('MFA requirement').t`Required` : c('MFA requirement').t`Not required`}
                    </Badge>
                </div>
            </div>

            <Button className="ml-auto" category="weak" onClick={() => setPending(!mfaRequired)}>
                {mfaRequired
                    ? c('MFA requirement action').t`Stop requiring it…`
                    : c('MFA requirement action').t`Require it…`}
            </Button>

            {pending !== null && (
                <MfaRequirementDialog
                    accountId={accountId}
                    accountName={accountName}
                    required={pending}
                    onClose={() => setPending(null)}
                />
            )}
        </div>
    );
};

export default MfaRequirementPanel;
